<template>
  <v-form ref="form" class="position-relative">
    <v-container v-if="siguiente === 'fase1'">
      <Primero :reglas="reglas" :modelo="data_form" />
      <Cuestionario :reglas="reglas" :cuestionario_data="cuestionario" />
      <v-row>
        <v-col cols="12" offset-sm="2" sm="10">
          <v-btn
            class=" siguiente blue white--text darken-3"
            @click="siguienteMet"
            :disabled="carga"
            >{{ $t("segundo.btn") }}</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else-if="siguiente === 'fase2'">
      <Culminar :data_form="data_form" id="top_g" />
      <CardFirst />
      <div class="d-flex justify-center verificado pt-5 pb-5">
        <img :src="imagen_verify" alt="" />
        <p>{{ $t("verificado") }}</p>
      </div>
      <p class="text-center grey--text text--darken-1">{{ $t("metodo") }}</p>
      <v-row>
        <v-col cols="12" md="6" offset-md="3">
          <v-expansion-panels class="mt-4">
            <v-expansion-panel>
              <v-expansion-panel-header class="green lighten-4">
                {{ $t("terminos_final.titulo") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <ol>
                  <li>{{ $t("terminos_final.lista_titulo_1.titulo") }}</li>
                  <ol
                    style="list-style: square; font-size : 90%"
                    class="grey--text text--darken-2"
                  >
                    <li v-for="i in 8" v-bind:key="i">
                      {{
                        $t(
                          "terminos_final.lista_titulo_1.listas[" +
                            (i - 1) +
                            "]"
                        )
                      }}
                      <a href="mailto:info@worldcobtrustseal.com" v-if="i == 7"
                        >info@worldcobtrustseal.com</a
                      >
                    </li>
                  </ol>
                  <li class="mt-5">
                    {{ $t("terminos_final.lista_titulo_2.titulo") }}
                  </li>
                  <ol
                    style="list-style: square; font-size : 90%"
                    class="grey--text text--darken-2"
                  >
                    <li v-for="i in 5" v-bind:key="i">
                      {{
                        $t(
                          "terminos_final.lista_titulo_2.listas[" +
                            (i - 1) +
                            "]"
                        )
                      }}
                    </li>
                  </ol>
                  <li class="mt-5">
                    {{ $t("terminos_final.lista_titulo_3.titulo") }}
                  </li>
                  <ol
                    style="list-style: square; font-size : 90%"
                    class="grey--text text--darken-2"
                  >
                    <li v-for="i in 3" v-bind:key="i">
                      <span class="text-decoration-underline"
                        >{{
                          $t(
                            "terminos_final.lista_titulo_3.sub_titulos[" +
                              (i - 1) +
                              "]"
                          )
                        }}:
                      </span>
                      <span>{{
                        $t(
                          "terminos_final.lista_titulo_3.listas[" +
                            (i - 1) +
                            "]"
                        )
                      }}</span>
                    </li>
                  </ol>
                </ol>
                <p class="mt-3">{{ $t("terminos_final.ultimo") }}</p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <Botones :data_form="data_form" />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <div>
        <v-btn
          class="transparent"
          style="box-shadow : none"
          @click="siguiente = 'fase1'"
        >
          <v-icon medium color="blue darken-2">
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </div>
      <h2 class="text-center display-4 mt-2">{{ data_form.nombre }}</h2>
      <h1 class="text-center  display-4 font-weight-bold">
        {{ $t("desaprobado") }}
      </h1>
      <h3 class="text-center display-1">{{ $t("desaprobado_2") }}</h3>
      <h3 class="text-center  display-1">{{ $t("desaprobado_3") }}</h3>
    </v-container>
  </v-form>
</template>

<script>
import validaciones from "../utils/rules";
import Primero from "./first";
import Cuestionario from "./cuestionario";
import Culminar from "./culminar_p";
import CardFirst from "./culminar_s";
import Botones from "./botones";
import axios from "axios";
import paises from "../assets/paises.json";
export default {
  name: "General",
  data: () => ({
    reglas: {
      ...validaciones,
    },
    data_form: {
      empresa: "",
      nombre: "",
      email: "",
      telefono: "",
      pais: "",
      pagina: "",
    },
    cuestionario: {
      pregunta_1: "",
      pregunta_2: "",
      pregunta_3: "",
      pregunta_4: "",
      pregunta_5: "",
      pregunta_6: "",
      terminos: "",
    },
    siguiente: "fase1",
    imagen_verify: require("../assets/verified-user-shield-check.png"),
    carga: false,
  }),
  components: {
    Primero,
    Cuestionario,
    Culminar,
    CardFirst,

    Botones,
  },
  mounted(){
    this.getParams()
  },
  methods: {
    getParams(){
      const queryString = window.location.search.split("&")
      const mapeo = queryString.map((e)=>e.split("=")[1] )
      if(mapeo.length===6){
        this.data_form.nombre = decodeURI(mapeo[0])
        this.data_form.empresa = decodeURI(mapeo[1])
        this.data_form.email = decodeURI(mapeo[3])
        this.data_form.telefono = decodeURI(mapeo[4])
        this.data_form.pais = paises.countries.filter((e)=> this.eliminarDiacriticos(e.text) === mapeo[5])[0].value
      }
    },
    /**
     * Elimina tildes
     * @param {string} texto
     */
    eliminarDiacriticos(texto) {
      return texto.normalize('NFD').replace(/[\u0300-\u036f]/g,"");
    },
    /**
     * Obtener pais string
     * @param {number} cod
     * @returns {string}
     */
    async getPais(cod) {
      return await paises.countries.filter((e) => e.value === cod);
    },
    async siguienteMet() {
      if (this.$refs.form.validate()) {
        if (
          this.cuestionario.pregunta_1 === "Si" &&
          this.cuestionario.pregunta_2 === "Si" &&
          this.cuestionario.pregunta_3 === "Si"
        ) {
          try {
            this.carga = true;
            let language = document.querySelector("html").getAttribute("lang");
            let data = new FormData();
            let pais = await this.getPais(this.data_form.pais);
            pais = pais[0].text;

            data.append("correo", this.data_form.email);
            data.append("lan", language);
            data.append("empresa", this.data_form.empresa);
            data.append("nombre", this.data_form.nombre);
            data.append("telefono", this.data_form.telefono);
            data.append("pagina", this.data_form.pagina);
            data.append("pais", pais);

            let respuestaEmail = await axios.post(
              process.env.VUE_APP_URL_SEND_MAIL + "send_mail.php",
              data
            );

            this.carga = false;
            if (respuestaEmail.data) {
              this.data_form.pais = pais
              this.siguiente = "fase2";
              window.scrollTo(0, 0); // values are x,y-offset
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          this.siguiente = "desaprobado";
        }
      }
    },
  },
};
</script>

<style>
html{
  scroll-behavior: smooth;
}
.caja_titulo {
  background: #64b5f6 !important;
  border-color: #64b5f6 !important;
}
.caja_titulo h2 {
  color: white;
  font-size: 24px !important;
  line-height: 32px !important;
  font-weight: 400;
}
button.siguiente.blue {
  width: 20% !important;
}
.titulo_aprobado {
  font-size: 56px !important;
  line-height: 1.35 !important;
  letter-spacing: -0.02em !important;
}
.titulo_user {
  font-size: 60px !important;
  font-weight: 300;
  line-height: 1 !important;
  letter-spacing: -0.04em !important;
  color: #757575 !important;
  caret-color: #757575 !important;
}
.video-success .checkmark {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  box-shadow: inset 0 0 0 #7ac142;
  animation: fill-aprobado 0.4s ease-in-out 0.4s forwards,
    escala-aprobado 0.3s ease-in-out 0.9s both;
}
@keyframes fill-aprobado {
  100% {
    box-shadow: inset 0 0 0 30px #7ac142;
    -webkit-box-shadow: inset 0 0 0 30px #7ac142;
  }
}
@keyframes escala-aprobado {
  0%,
  100% {
    transform: none;
    -webkit-transform: none;
  }

  50% {
    -webkit-transform: scale3d(1.1, 1.1, 1);
    transform: scale3d(1.1, 1.1, 1);
  }
}
h3.text-center:not(.title_botton) {
  font-weight: 400;
  letter-spacing: normal !important;
  font-size: 30px;
}
.verificado {
  align-items: center;
}
.verificado img {
  max-width: 150px;
}
.verificado p {
  font-size: 24px !important;
  color: #01579b !important;
  caret-color: #01579b !important;
  font-weight: 700 !important;
}
.todo {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: white;
  z-index: 111111111111111;
  display: none;
  justify-content: center;
  align-items: center;
}
</style>
